import chiaraPic from "@/public/images/artists/chiara.png";
import { Artist } from "@/types/types";

export const chiara = {
  id: "254",
  name: "Chiara",
  image: chiaraPic,
  description: `Chiara's voice has a rich, amber-toned timbre. It's warm at the core with a gritty edge that surfaces when she leans in. Her delivery is expressive and dynamic, shifting effortlessly between velvety, controlled runs and raw, cutting belts.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fchiara-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "Soul", "RnB", "Blues", "Jazz", "Disco"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "High",
      },
      specific: {
        low: 48,
        high: 72,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
